(() => {
	const siteName = 'default-package_2023_vanilla';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 152,
				sp: 76
			}
		},
		localDecision() {
			const regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|127\\.0\\.0\\.1)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						// console.log('Succeeded to read the include file!:', position);
					});

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(ele => {
				hash = ele.split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		nextToggle() {
			const switchElements = document.querySelectorAll('.js-toggle');

			switchElements.forEach(switchElement => {
				switchElement.addEventListener('click', e => {
					e.currentTarget.classList.toggle(a);

					let toggleBlock = e.currentTarget.nextElementSibling;
					toggleBlock.classList.toggle(a);
					if (toggleBlock.style.height) {
						toggleBlock.style.height = null;
						toggleBlock.style.visibility = 'hidden';
					} else {
						toggleBlock.style.height = toggleBlock.scrollHeight + 'px';
						toggleBlock.style.visibility = 'visible';
					}
				});
			});
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length) {
				// ハッシュタグで絞り込み
				if (location.hash) {
					let hash = location.hash.split('#')[1];
					$tab.forEach(ele => {
						ele.classList.remove(a);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.remove(a);
						}
					});
					$content.forEach(ele => {
						ele.classList.remove(a);
						ele.classList.remove(v);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						}
					});
				}

				$tab.forEach(ele => {
					ele.addEventListener('click', () => {
						$tab.forEach(ele2 => { ele2.classList.remove(a); })
						ele.classList.add(a);
						$content.forEach(ele => {
							ele.classList.remove(a);
							ele.classList.remove(v);
						});

						let $target;
						let target = ele.getAttribute('data-target');
						if (target === 'all') {
							$target = $content;
						} else {
							$target = document.querySelectorAll('[data-target="' + target + '"]');
						}
						$target.forEach(ele => {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						});
					});
				});
			}
		},
		easeScroll() {
			const scrollToObject = (_self) => {
				let hash = _self.currentTarget.href.split('#')[1];
				let pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;

				if (hash !== 'pagetop') {
					if(document.querySelectorAll('.recruit-header').length) {
						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos = pos - 60;
						} else {
							pos = pos - 130;
						}
					} else {
						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos = pos - FUNCTIONS.va.header.sp;
						} else {
							pos = pos - 60;
						}
					}
				}

				window.scrollTo({ top: pos, behavior: 'smooth' });
			}
			// フォーカス用関数
			const scrollFocus = (_hash) => {
				let hash = _hash;
				// console.log('hash', hash);
				if (hash !== 'pagetop') {
					const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					const focusableElements = Array.from(
						document.getElementById(hash).querySelectorAll(focusableElementsSelector)
					);
					if (focusableElements.length) {
						focusableElements[0].focus({ preventScroll: true });
					}
				}
			};
			// スクロール完了後に実行する関数
			let scrollResolveTimeout;
			const waitForScrollComplete = (_hash) => {
				return new Promise((resolve) => {
					const scrollTimeout = setTimeout(() => {
						resolve(true);
					}, 100);
					const scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
						clearTimeout(scrollTimeout);
						clearTimeout(scrollResolveTimeout);
						scrollResolveTimeout = setTimeout(function () {
							scrollFocus(_hash);
							removeEventListener('scroll', fn);
							resolve(true);
						}, 100);
					});
				});
			};
			document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
				ele.addEventListener('click', async (e) => {
					e.preventDefault();
					if (/#/.test(e.currentTarget.href)) {

						scrollToObject(e);
						let hash = e.currentTarget.href.split('#')[1];

						await waitForScrollComplete(hash);
						return false;
					}
				});
			});
		},
		easeScrollHash() {
			const hash = location.hash;
			// console.log(hash)
			if (hash) {
				// console.log(hash + "_")
				// フォーカス用関数
				const scrollFocus = (_hash) => {
					let hash = _hash;
					if (hash !== 'pagetop') {
						const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						if (document.getElementById(hash)?.querySelectorAll(focusableElementsSelector)) {
							const focusableElements = Array.from(
								document.getElementById(hash)?.querySelectorAll(focusableElementsSelector)
							);
							if (focusableElements.length) {
								focusableElements[0].focus({ preventScroll: true });
							}
						}
					}
				}
				// スクロール完了後に実行する関数
				let scrollResolveTimeout;
				const waitForScrollComplete = (_hash) => {
					return new Promise((resolve) => {
						const scrollTimeout = setTimeout(() => {
							resolve(true);
						}, 100);
						const scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
							clearTimeout(scrollTimeout);
							clearTimeout(scrollResolveTimeout);
							scrollResolveTimeout = setTimeout(function () {
								scrollFocus(_hash);
								removeEventListener('scroll', fn);
								resolve(true);
							}, 100);
						});
					});
				}

				const hashScroll = () => {
					let pos = document.getElementById(hash?.split('#')[1])?.getBoundingClientRect()?.top + window.scrollY;
					if (hash !== 'pagetop') {
						if(document.querySelectorAll('.recruit-header').length) {
							if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
								pos = pos - 60;
							} else {
								pos = pos - 130;
							}
						} else {
							if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
								pos -= FUNCTIONS.va.header.sp;
							} else {
								pos -= FUNCTIONS.va.header.desktop;
							}
						}
					}
					FUNCTIONS.matchHeight();
					window.scrollTo({ top: pos, behavior: 'auto' });
				}

				// loadが発火しないことがあるためload完了後だったら即時発火
				if (document.readyState === "complete") {
					(async () => {
						setTimeout(() => {
							hashScroll();
						}, 100);
						await waitForScrollComplete(hash);
					})();
				} else {
					window.addEventListener('load', async () => {
						setTimeout(() => {
							hashScroll();
						}, 100);
						await waitForScrollComplete(hash);
					});
				}
			}
		},
		pageTop() {
			let footer = document.querySelector('.footer');
			let $pagetop = document.querySelector('.footer-pagetop');

			if ($pagetop) {
				window.addEventListener('scroll', (e) => {
					if (window.scrollY > '100') {
						$pagetop.classList.add(v);
					} else {
						$pagetop.classList.remove(v);
					}
				});
			}
		},
		setImgAttrWidthHeight() {
			const getImg = (_src) => {
				return new Promise((resolve, reject) => {
					const image = new Image();
					image.src = _src;
					image.onload = () => { resolve(image); }
					image.onerror = (error) => { reject(error); }
				});
			};

			const imgs = document.getElementsByTagName('img');

			for (const img of imgs) {
				const src = img.getAttribute('src');
				getImg(src).then((res) => {
					if (!img.hasAttribute('width')) {
						img.setAttribute('width', res.width);
					}
					if (!img.hasAttribute('height')) {
						img.setAttribute('height', res.height);
					}
				})
					.catch((error) => { console.log(error); });
			}
		},
		setModal() {
			const createModal = (_appendHTML, _target) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
								_target.focus();
							}, 400);
						});
					});
					window.addEventListener("keydown", function (event) {
						if (document.querySelectorAll('.mod-modal-overlay').length) {
							// タブキーが押された時
							if (event.key === "Tab") {
								event.preventDefault();
								// モーダル要素内のフォーカス可能な要素の一覧を取得
								const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
								const focusableElements = Array.from(
									document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector)
								);
								// 現在のフォーカス位置を取得
								const focusedItemIndex = focusableElements.indexOf(document.activeElement);
								// shiftキーと同時に押されてた場合
								if (event.shiftKey) {
									if (focusedItemIndex === 0) {
										// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
										focusableElements[focusableElements.length - 1].focus();
									} else {
										// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
										focusableElements[focusedItemIndex - 1].focus();
									}
								} else {
									if (focusedItemIndex === focusableElements.length - 1) {
										// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
										focusableElements[0].focus();
									} else {
										// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
										focusableElements[focusedItemIndex + 1].focus();
									}
								}
							}
							// ESCキーが押された時
							if (event.key === "Escape") {
								event.preventDefault();
								$container.classList.remove(v);
								setTimeout(() => {
									$container.classList.remove(a);
									$container.remove();
									_target.focus();
								}, 400);
							}
						}
					});
				});
			};
			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content.outerHTML) {
						let appendHTML = `<div class="mod-modal-closeArea"></div>
							${$content.outerHTML}`;
						createModal(appendHTML, e.currentTarget);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML, e.currentTarget);
					return false;
				});
			});
		},
		matchHeight() {
			const $elements = document.querySelectorAll('[data-mh]');
			const groups = new Map();

			$elements.forEach(ele => { ele.style.height = 'auto'; }); // 初期化

			$elements.forEach(ele => {
				const attributeName = ele.getAttribute('data-mh');
				if (!groups.has(attributeName)) {
					groups.set(attributeName, []);
				}
				groups.get(attributeName).push(ele);
			});
			groups.forEach(group => {
				const attributeGroups = new Map();
				group.forEach(ele => {
					const attributeName = ele.getAttribute('data-mh');
					const topPosition = ele.getBoundingClientRect().top;
					const key = attributeName + '_' + topPosition;
					if (!attributeGroups.has(key)) {
						attributeGroups.set(key, []);
					}
					attributeGroups.get(key).push(ele);
				});
				attributeGroups.forEach((item) => {
					const maxHeight = Math.max(...item.map(ele => ele.offsetHeight));
					item.forEach((ele2) => {
						if (maxHeight > 0) {
							ele2.style.height = `${maxHeight}px`;
						}
					});
				});
			});
		},
		inViewAnimation() {
			const target = document.querySelectorAll('.js-fade');
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback, options);

			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		inViewAnimationImg() {
			const target = document.querySelectorAll('.js-fade-img');
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback, options);

			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		headerHamburger() {
			const $hamburger = document.querySelectorAll('.header-hamburger');
			const $nav = document.querySelector('.header-nav');
			const $container = document.querySelector('.container');
			let scrollTopNow;

			const fixedOnContainer = () => {
				scrollTopNow = window.scrollY;
				$container.style.position = 'fixed';
				$container.style.width = '100%';
				$container.style.zIndex = '1000';
				$container.style.top = -1 * scrollTopNow;
				$container.style.left = 0;
				document.body.classList.add(f);
			};
			const fixedOffContainer = () => {
				$container.style.position = 'static';
				document.body.classList.remove(f);
				window.scrollTo({ top: scrollTopNow });
			};

			if ($hamburger) {
				$hamburger.forEach((ele, idx) => {
					ele.addEventListener('click', (e) => {
						$hamburger.forEach((ele2, idx2) => {
							ele2.classList.toggle(a);
						});
						if ($nav.classList.contains(a)) {
							$nav.classList.remove(v);
							$nav.classList.remove(a);
							fixedOffContainer();
						} else {
							fixedOnContainer();
							$nav.classList.add(a);
							setTimeout(() => { $nav.classList.add(v); });
						}
					});
				});

				// ヘッダーメニュー内のリンクをクリックしたらヘッダーメニュー閉じる
				document.querySelectorAll('.header-megamenu-item-list .__link').forEach(ele => {
					ele.addEventListener('click', (e) => {
						if(e.currentTarget.tagName == "P") return;
						fixedOffContainer();
						$hamburger[0].classList.remove(a);
						$hamburger[1].classList.remove(a);
						$nav.classList.remove(v);
						$nav.classList.remove(a);
					})
				});

				document.querySelectorAll('.header-megamenu-item .__bnr').forEach(ele => {
					ele.addEventListener('click', (e) => {
						fixedOffContainer();
						$hamburger[0].classList.remove(a);
						$hamburger[1].classList.remove(a);
						$nav.classList.remove(v);
						$nav.classList.remove(a);
					})
				});
			}
		},
		fileSize() {
			const bytesToSize = (bytes) => {
				const kilobytes = bytes / 1024;
				const nf = new Intl.NumberFormat('en-US');
				return nf.format(kilobytes.toFixed(0));
			}
			if (document.querySelectorAll('.js-fileSize').length) {
				document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
					pdfElement.innerText = bytesToSize(pdfElement.innerText).toLocaleString() + 'KB';
				});
			}
		},
		isScroll() {
			// スクロールされたときヘッダーの色変更
			let currentPosition = 0;

			const isAtTheTop = () => {
				const scroll = window.scrollY;
				const $headerInner = document.querySelector('.header');
				if (scroll > 0) {
					$headerInner.classList.add('is-scroll')
				} else {
					$headerInner.classList.remove('is-scroll')
				}
			}
			const isDown = () => {
				const scroll = window.scrollY;
				const $headerInner = document.querySelector('.header');
				if (scroll > currentPosition) {
					$headerInner.classList.add('is-down')

					// 開いているメガメニューを閉じる
					if(document.querySelector('.js-megaMenu-block.is-active')) {
						document.querySelector('.js-megaMenu-block.is-active').classList.remove(a);
						if(document.querySelector('.js-megaMenu.is-active')) {
							document.querySelector('.js-megaMenu.is-active').classList.remove(a);
						}
					}
				} else {
					$headerInner.classList.remove('is-down')
				}
				currentPosition = scroll
			}

			isAtTheTop()

			window.addEventListener("scroll", function () {
				isAtTheTop()
				isDown()
			});
		},
		headerMegamenu() {
			const $header = document.querySelector('header');
			const noTransition = 'is-noTransition';
			// メガメニュー表示／非表示
			let megaMenu = document.querySelectorAll('.header-nav-main-item>a.__link');
			megaMenu.forEach(ele => {
				// カレント
				if (FUNCTIONS.va.pathname.indexOf(ele.getAttribute('href')) === 0) {
					ele.classList.add('current');
				}
				// マウスが動いたときのみ発火
				$header.addEventListener('mousemove', () => {
					// マウスオーバーで表示
					ele.addEventListener('mouseover', (e) => {
						menuClose();
						$header.classList.add('is-scroll');
						if (ele.classList.contains('js-megaMenu')) {
							ele.classList.add(a);
							let thisName = ele.getAttribute('data-name');
							let thisMegaMenu = document.querySelector('.js-megaMenu-block[data-name="' + thisName + '"]');
							thisMegaMenu.classList.add(a);
							// thisMegaMenu.style.height = thisMegaMenu.scrollHeight + 'px';
						} else {
							document.querySelectorAll('.js-megaMenu-block').forEach(ele => {
								ele.classList.remove(noTransition);
							});
						}
					});
				});

				ele.addEventListener("keydown", (e) => {
					// Enterキーでメガメニューの開閉
					if (e.keyCode === 13) {
						menuClose();
						if (ele.classList.contains('js-megaMenu')) {
							let thisName = ele.getAttribute('data-name');
							let thisMegaMenu = document.querySelector('.js-megaMenu-block[data-name="' + thisName + '"]');
							if (thisMegaMenu.classList.contains(a)) {
								setTimeout(function () {
									ele.setAttribute('href', ele.getAttribute('data-href'));
								}, 100);
							} else {
								ele.setAttribute('data-href', new URL(ele.href).pathname);
								ele.setAttribute('href', 'javascript:void(0)');
							}
							thisMegaMenu.classList.toggle(a);
						}
					}
					// ESCキーでメガメニューを閉じる
					if (e.keyCode === 27) {
						// console.log('ESC',ele.children[0]);
						if (ele.children[0].classList.contains(a)) {
							ele.children[0].classList.remove(a);
							ele.children[1].classList.remove(a);
						}
					}
					// メガメニューを開いた状態で、一つ前の項目に移動した場合、メガメニューを閉じる
					if (e.shiftKey) {
						if (e.keyCode === 9) {
							// console.log('shiftKey');
							if (ele.children[0].classList.contains(a)) {
								ele.children[0].classList.remove(a);
								ele.children[1].classList.remove(a);
							}
						}
					}
				});
			});
			// メガメニュー内aタグ・buttonタグ選択時escキーで閉じる
			let megahead = document.querySelectorAll('.header-nav-main a,.header-nav-main button');
			megahead.forEach(ele => {
				ele.addEventListener("keydown", (e) => {
					// ESCキーでメガメニューを閉じる
					if( e.keyCode === 27 ){
						menuClose();
					}
				});
			});
						
			// オーバーレイにマウスオンでメガメニュー非表示
			let megaMenuBlock = document.querySelectorAll('.header-megamenu-overlay');
			megaMenuBlock.forEach(ele => {
				ele.addEventListener('mouseover', (e) => {
					menuClose();
					document.querySelectorAll('.js-megaMenu-block').forEach(ele => {
						ele.classList.remove(noTransition);
					});
				});
			});

			// <SP> ==========
			// メガメニュー開閉
			let spMegaMenu = document.querySelectorAll('button.js-megaMenu');
			if (spMegaMenu.length) {
				spMegaMenu.forEach(ele => {
					ele.addEventListener('click', (e) => {
						let thisName = e.currentTarget.getAttribute('data-name');
						let thisMegaMenu = document.querySelector('.js-megaMenu-block[data-name="' + thisName + '"]');
						e.currentTarget.classList.toggle(a);
						thisMegaMenu.classList.toggle(a);
					});
				});
			}
			// メガメニュー閉じる
			const menuClose = () => {
				$header.classList.remove('is-scroll');
				let activeBtn = document.querySelectorAll('.js-megaMenu.is-active');
				let activeBlock = document.querySelectorAll('.js-megaMenu-block.is-active');

				if (activeBlock.length) {
					document.querySelectorAll('.js-megaMenu-block').forEach(ele => {
						ele.classList.add(noTransition);
					});
				} else {
					document.querySelectorAll('.js-megaMenu-block').forEach(ele => {
						ele.classList.remove(noTransition);
					});
				}

				if (activeBtn.length) {
					activeBtn[0].classList.remove(a);
				}
				if (activeBlock.length) {
					activeBlock[0].classList.remove(a);
				}
			}

			// ページ内リンクになる場合、rel="scroll"を付与
			const $scrollItem = document.querySelectorAll('.js-megamenuLink-scroll');
			if($scrollItem.length) {
				$scrollItem.forEach(ele => {
					let thisHref = ele.getAttribute('href').split('#')[0];
					if(thisHref === FUNCTIONS.va.pathname) {
						ele.setAttribute('rel', 'scroll');
						FUNCTIONS.easeScroll();
					}
				});
			}
		},
		siteSearch() {
			const $header = document.querySelector('.header');
			const $searchBtn = document.querySelector('.js-header-search');
			const $searchBlock = document.querySelector('.js-header-searchBlock');
			const $recruitHeader = document.querySelector('.recruit-header');
			if ($searchBtn) {
				// 検索窓開く
				$searchBtn.addEventListener('click', () => {
					$searchBlock.classList.add(a);
					document.querySelectorAll('.header-nav-sub > li:not(.js-header-searchWrap)').forEach(function (li) {
						li.classList.add('di_none');
					});
					$header.classList.add('js-header-searchClose');

					if ($recruitHeader) {
						$recruitHeader.classList.add('search-open');
					}
				});
				// 検索窓閉じる
				document.querySelector('.contents').addEventListener('click', function (e) {
					if (!e.currentTarget.classList.contains('js-header-search')) {
						$searchBlock.classList.remove(a);
						document.querySelectorAll('.header-nav-sub > li:not(.js-header-searchWrap)').forEach(function (li) {
							li.classList.remove('di_none');
						});

						if ($recruitHeader) {
							$recruitHeader.classList.remove('search-open');
						}
					}
				});
				$header.addEventListener('click', function (e) {
					let target = e.target;
					let isInside = false;
					while (target !== null && !isInside) {
						if (target.classList.contains('js-header-search') || target.classList.contains('js-header-searchBlock')) {
							isInside = true;
						} else {
							target = target.parentElement;
						}
					}
					if (!isInside) {
						$searchBlock.classList.remove(a);
						document.querySelectorAll('.header-nav-sub > li:not(.js-header-searchWrap)').forEach(function (li) {
							li.classList.remove('di_none');
						});

						if ($recruitHeader) {
							$recruitHeader.classList.remove('search-open');
						}
					}
				});
			}

			(function () {
				var s = document.createElement('script');
				s.src = '/common/js/siteSearch.js';
				document.getElementsByTagName('body')[0].appendChild(s);
			})();
		},
		urlcurrent() {
			const urlcurrent = document.querySelectorAll('.js-urlcurrent')
			if (urlcurrent.length) {
				urlcurrent.forEach(elem => {
					if (elem.pathname.replace('index.html', '') == location.pathname.replace('index.html', '')) {
						elem.classList.add(a);
						elem.classList.add(v);
					}
				});
			}
		},
		localNav() {
			const localNavItem = document.querySelectorAll('.js-localNav');
			let pathName = FUNCTIONS.va.pathname.split("/");
			let lang = FUNCTIONS.va.pathname.includes('/english/') ? '/english' : '';
			let _pathName = "";
			pathName.length = FUNCTIONS.va.pathname.includes('/english/') ? 4 : 3;
			pathName = pathName.join("/") + "/";

			if(pathName == lang + "/sustainability/tcfd/" ||
				pathName == lang + "/sustainability/performance-target/"
			) {
				_pathName = lang + "/sustainability/environment/";
			}

			if(pathName == lang + "/sustainability/supplychain/" ||
				pathName == lang + "/sustainability/employees/"
			) {
				_pathName = lang + "/sustainability/humanrights/";
			}

			if(pathName == lang + "/sustainability/esg-topics/" ||
				pathName == lang + "/sustainability/policy/" ||
				pathName == lang + "/sustainability/gri-external/" ||
				pathName == lang + "/sustainability/external-evaluation/" ||
				pathName == lang + "/sustainability/disclosure-policy/" ||
				pathName == lang + "/sustainability/financial-data/" ||
				pathName == lang + "/sustainability/report/"
			) {
				_pathName = lang + "/sustainability/esg-topics/";
			}

			if(pathName == lang + "/sustainability/governance-system/" ||
				pathName == lang + "/sustainability/board/"
			) {
				_pathName = lang + "/sustainability/governance/";
			}

			if (localNavItem.length) {
				localNavItem.forEach(ele => {
					// console.log(ele)
					// console.log(pathName)
					// console.log("-----")
					if (ele.getAttribute('href') === FUNCTIONS.va.pathname || ele.getAttribute('href') + 'index.html' === FUNCTIONS.va.pathname || ele.getAttribute('href') === pathName || ele.getAttribute('href') === _pathName) {
						ele.classList.add(a);
						if (ele.nextElementSibling !== null) {
							if (FUNCTIONS.va.window.width > FUNCTIONS.va.device.desktop) {
								let thisSubMenu = ele.nextElementSibling.nextElementSibling;
								// console.log(thisSubMenu);
								document.querySelector('.mod-localNav').appendChild(thisSubMenu);
							}
						}
					}
				});
			}
			// console.log("---------------")
			const localNanSub = document.querySelectorAll('.js-localNav-sub');
			
			if (localNanSub.length) {
				localNanSub.forEach(ele => {
					// console.log(ele)
					// console.log(pathName)
					// console.log("-----")
					if (ele.getAttribute('href') === FUNCTIONS.va.pathname || ele.getAttribute('href') + 'index.html' === FUNCTIONS.va.pathname || ele.getAttribute('href') === pathName) {
						ele.classList.add(a);
						let thisSubMenu = ele.closest('.mod-localNav-sub');
						if (ele && ele.previousElementSibling !== null) {
							thisSubMenu.previousElementSibling.previousElementSibling.classList.add(a);
							if (FUNCTIONS.va.window.width > FUNCTIONS.va.device.desktop) {
								document.querySelector('.mod-localNav').appendChild(thisSubMenu);
							}
						}
					}
				});
			}

			let flg = '';
			window.addEventListener('resize', () => {
				let winW = window.innerWidth;
				if (winW > FUNCTIONS.va.device.desktop) {
					if (flg !== 'pc') {
						flg = 'pc';
						let activeItem = document.querySelector('.js-localNav.is-active');
						if (activeItem && !document.querySelector('.mod-localNav > .mod-localNav-sub')) {
							let thisSubMenu = activeItem.nextElementSibling.nextElementSibling;
							document.querySelector('.mod-localNav').appendChild(thisSubMenu);
						}
					}
				} else {
					if (flg !== 'sp') {
						flg = 'sp';
					}
				}
			});
		},
		loadDelayScript() {
			let _this = this;
			_this.nextToggle();
			_this.tabSwitch();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.setImgAttrWidthHeight();
			_this.setModal();
			_this.inViewAnimation();
			_this.inViewAnimationImg();
			_this.headerHamburger();
			_this.fileSize();
			_this.isScroll();
			_this.headerMegamenu();
			_this.siteSearch();
			_this.urlcurrent();
			_this.localNav();
			let resizeTime = 0;

			window.addEventListener('load', () => { _this.matchHeight(); });

			window.addEventListener('resize', () => {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => { _this.matchHeight(); }, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();
// ブラウザバック対応
window.onpageshow = function (event) {
	if (event.persisted) {
		window.location.reload();
	}
};
